import axios from "@/plugins/axios";

export default {
    actions: {
        fetchSaleEmployeeYearly(context, searchItem) {
            let url = "sale_employee_yearlies?page="  + searchItem.page

            if (!context.state.saleEmployeeYearly.isNeedFetch && !searchItem.isNeedFetch) {
                return
            }

            if (searchItem.byTotalSum) {
                url = url + '&order[totalSum]=desc'
            } else if (searchItem.byAverage) {
                url = url + '&order[average]=desc'
            } else if (searchItem.byReceiptAmount) {
                url = url + '&order[amount]=desc'
            } else if (searchItem.byIncome) {
                url = url + '&order[income]=desc'
            }

            if (searchItem.before) {
                url = url + '&date[before]=' + searchItem.before
            }

            if (searchItem.after) {
                url = url + '&date[after]=' + searchItem.after
            }

            if (searchItem.givenName) {
                url = url + "&person.givenName=" + searchItem.givenName
            }

            return axios.get(url)
                .then((response) => {
                    console.log(response)

                    let data = {
                        models: response.data['hydra:member'],
                        totalItems: response.data['hydra:totalItems']
                    }

                    context.commit('updateSaleEmployeeYearly', data)
                })
                .catch((err) => {
                    console.log(err)
                })
        },
    },
    mutations: {
        updateSaleEmployeeYearly(state, data) {
            state.saleEmployeeYearly = data
            state.saleEmployeeYearly.isNeedFetch = false
        },
    },
    state: {
        saleEmployeeYearly: {
            models: [],
            totalItems: 0,
            isNeedFetch: true
        },
    },
    getters: {
        getSaleEmployeeYearly(state) {
            return state.saleEmployeeYearly.models
        },
        getSaleEmployeeYearlyTotalCount(state) {
            return state.saleEmployeeYearly.totalItems
        },
    },
}
